import { useTranslation } from "react-i18next";

// Rodapé do case: "Tecnologias usadas" e os chips, alternando cinza e rosa.
export default function CaseTechs({ techs }: { techs: string[] }) {
  const { t } = useTranslation();

  return (
    <div className="cz-case-panel__techs">
      <span className="cz-case-panel__techs-title">{t("cases_page.labels.techs")}</span>
      <ul className="cz-case-chips">
        {techs.map((tech, i) => (
          <li key={tech} className={`cz-case-chip${i % 2 ? " cz-case-chip--alt" : ""}`}>
            {tech}
          </li>
        ))}
      </ul>
    </div>
  );
}
